import { Text } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';

export function ErrorFallbackVwView(): ReactElement {
  return <Text>An error has occurred. Please, refresh the page and try again.</Text>;
}
